import React from "react";

export function TelegramAppColored({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9998 4.16675C19.4745 4.16675 14.1755 6.36168 10.2684 10.2687C6.36144 14.1757 4.1665 19.4747 4.1665 25.0001C4.1665 30.5254 6.36144 35.8245 10.2684 39.7315C14.1755 43.6385 19.4745 45.8334 24.9998 45.8334C30.5252 45.8334 35.8242 43.6385 39.7312 39.7315C43.6382 35.8245 45.8332 30.5254 45.8332 25.0001C45.8332 19.4747 43.6382 14.1757 39.7312 10.2687C35.8242 6.36168 30.5252 4.16675 24.9998 4.16675Z"
        fill="#29B6F6"
      />
      <path
        d="M35.3644 15.6249L31.4623 35.5478C31.4623 35.5478 31.2946 36.4583 30.1655 36.4583C29.5655 36.4583 29.2561 36.1728 29.2561 36.1728L20.804 29.1593L16.6686 27.0749L11.3613 25.6635C11.3613 25.6635 10.4165 25.3905 10.4165 24.6093C10.4165 23.9583 11.3884 23.6478 11.3884 23.6478L33.5925 14.827C33.5925 14.827 34.2707 14.5822 34.7655 14.5833C35.0696 14.5833 35.4165 14.7135 35.4165 15.1041C35.4165 15.3645 35.3644 15.6249 35.3644 15.6249Z"
        fill="white"
      />
      <path
        d="M23.9582 31.776L20.3895 35.2906C20.3895 35.2906 20.2342 35.4104 20.027 35.4156C19.9551 35.4176 19.878 35.4062 19.7988 35.3708L20.803 29.1572L23.9582 31.776Z"
        fill="#B0BEC5"
      />
      <path
        d="M31.1425 18.9541C30.9665 18.7249 30.6415 18.6832 30.4123 18.8572L16.6665 27.0832C16.6665 27.0832 18.8603 33.2207 19.1946 34.2832C19.53 35.3468 19.7988 35.3718 19.7988 35.3718L20.803 29.1582L31.0446 19.6832C31.2738 19.5093 31.3165 19.1832 31.1425 18.9541Z"
        fill="#CFD8DC"
      />
    </svg>
  );
}
